// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-sharer .medium-button-container:last-child>button[data-v-e6df63ec]{margin-right:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
